import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-custom-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custom-toast.component.html',
  styleUrls: ['./custom-toast.component.scss'],
  animations: [
    trigger('flyInOut', [
      state('inactive', style({ opacity: 0, transform: 'translateY(20px)' })),
      state('active',   style({ opacity: 1, transform: 'translateY(0)' })),
      state('removed',  style({ opacity: 0, transform: 'translateY(20px)' })),
      transition('inactive => active', animate('200ms ease-out')),
      transition('active => removed',  animate('150ms ease-in')),
    ]),
  ],
  // Tell ngx-toastr to use this component's animation state
  preserveWhitespaces: false,
})
export class CustomToastComponent extends Toast implements OnInit {

  /** SafeHtml so Angular doesn't strip the SVG markup */
  iconSvg!: SafeHtml;

  // Toast types emitted by ngx-toastr
  private static readonly ICONS: Record<string, string> = {
    // Green tick
    'toast-success': `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="9" stroke="#4CAF50" stroke-width="2"/>
        <path d="M5.5 10.5L8.5 13.5L14.5 7.5" stroke="#4CAF50" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`,

    // Red cross
    'toast-error': `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="9" stroke="#F44336" stroke-width="2"/>
        <path d="M7 7L13 13M13 7L7 13" stroke="#F44336" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`,

    // Blue info circle
    'toast-info': `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="9" stroke="#CDDBFC" stroke-width="2"/>
        <path d="M10 9V14" stroke="#CDDBFC" stroke-width="2" stroke-linecap="round"/>
        <circle cx="10" cy="6.5" r="1" fill="#CDDBFC"/>
      </svg>`,

    // Yellow warning triangle
    'toast-warning': `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.134 3.5c.385-.667 1.347-.667 1.732 0l7.062 12.25c.385.666-.096 1.5-.866 1.5H2.938c-.77 0-1.25-.834-.866-1.5L9.134 3.5Z"
              stroke="#FFC107" stroke-width="2"/>
        <path d="M10 8.5V12" stroke="#FFC107" stroke-width="2" stroke-linecap="round"/>
        <circle cx="10" cy="14.5" r="1" fill="#FFC107"/>
      </svg>`,
  };

  constructor(
    protected override toastrService: ToastrService,
    public override toastPackage: ToastPackage,
    private sanitizer: DomSanitizer,
  ) {
    super(toastrService, toastPackage);
  }

  ngOnInit(): void {
    const raw = CustomToastComponent.ICONS[this.toastPackage.toastType]
      ?? CustomToastComponent.ICONS['toast-info'];
    // bypassSecurityTrustHtml is safe here — SVG is a compile-time constant, not user input
    this.iconSvg = this.sanitizer.bypassSecurityTrustHtml(raw);
  }

  action(event: MouseEvent): void {
    event.stopPropagation();
    this.toastPackage.triggerAction();
  }
}